export default "__VITE_ASSET__C8nE7S6S__"